<template>
  <component
    :is="currentComp"
    v-if="currentComp"
    :props-option="propsOption"
  />
</template>

<script>
import ToolPayment from '@/components/toolPayment/Index.vue'
export default {
  components: {
    ToolPayment
  },
  data () {
    return {
      currentComp: 'ToolPayment',
      propsOption: {
        toolObj: {
          img: require('@/assets/images/toolpayment/adblock-cover-big.png'),
          tit: '弹窗拦截强力扫描',
          desc: ['会员免广告，拦截不友好恶意弹窗', '拦截捆绑静默安装']
        },
        chargeType: [7],
        permissionName: 'popwindow_block'
      }
    }
  }
}
</script>
